import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { login as loginAction } from '../store/actions';
import Router from '@wetransfer/transfer/modules/router';
import { State } from '@wetransfer/transfer/store/types';

const mapState = ({ auth, user }: State) => ({
  isInitialized: auth.isInitialized,
  isLoggedIn: user.loggedIn,
});
const mapDispatch = { login: loginAction };
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;

export const SignIn = ({
  isInitialized,
  isLoggedIn,
  login,
}: Props): JSX.Element => {
  useEffect(() => {
    if (isInitialized) {
      if (!isLoggedIn) {
        login();

        return;
      }

      Router.navigateTo('/');
    }
  }, [isInitialized, isLoggedIn, login]);

  return null;
};

export default connector(SignIn);
